module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_6_A_11.e7fc2ab2.mp3";